import { RichText, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import styles from './RichText.module.scss';
import { ComponentProps } from 'lib/component-props';

type Props = Pick<ComponentProps, 'rendering'> & {
  fields: {
    description?: RichTextField;
  };
  spacingType?: 'tight' | 'default';
  className?: string;
};

const ScRichText = ({ fields, spacingType, className, rendering }: Props) => {
  const anchorId = rendering?.params?.anchorId;
  const spacingClass =
    spacingType === 'tight' ? styles['spacing-tight'] : styles['spacing-default'];
  return (
    <RichText
      id={anchorId}
      className={classNames(className, spacingClass, {
        [styles['sc-rich-text']]: true,
      })}
      field={fields.description}
    />
  );
};

export default ScRichText;
